// extracted by mini-css-extract-plugin
module.exports = {"container":"_3IyYP","left":"_3D2sZ","wrapper":"HDpeT","titleWrapper":"_31hp8","title":"_3rCzg","descriptionWrapper":"_24Ao4","description":"_1qdGN"};